import {FC} from 'react';
import {DiaryRow} from './types';
import {TableMobileItem} from './styles';
import {DocumentIcon} from 'shared/ui/icons';
import {formatDate, formatDistanceToNowStrict} from 'date-fns';
import {ru} from 'date-fns/locale';

type DiaryMobileTableProps = {
  rows: DiaryRow[];
  onRowClick: (row: DiaryRow) => void;
};

export const DiaryMobileTable: FC<DiaryMobileTableProps> = ({rows, onRowClick}) => {
  return (
    <>
      {rows.map((el) => (
        <TableMobileItem key={el.id} onClick={() => onRowClick(el)}>
          <i>
            <DocumentIcon />
          </i>
          <div>
            {formatDate(el.inspectedAt, 'dd.MM.yyyy')} • Улей №{el.hiveNumber}
          </div>
          <span>
            Обновлено{' '}
            {formatDistanceToNowStrict(el.updatedAt, {
              locale: ru,
              addSuffix: true,
            })}
          </span>
        </TableMobileItem>
      ))}
    </>
  );
};
